import './listing-share-buttons.css';
import { InlineShareButtons } from 'sharethis-reactjs';
import { useEffect, useRef } from 'react';

export interface ListingShareButtonsProps {
  close(): void;
}

export const ListingShareButtons = (props: ListingShareButtonsProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const handleClickOutside = (event: any) => {
    if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
      props.close();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside)
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  });

  return (
    <div ref={ref => (containerRef.current = ref)} className="listing-share-buttons">
      <InlineShareButtons
        config={{
          alignment: 'center',  // alignment of buttons (left, center, right)
          color: 'social',      // set the color of buttons (social, white)
          enabled: true,        // show/hide buttons (true, false)
          font_size: 16,        // font size for the buttons
          labels: null,        // button labels (cta, counts, null)
          language: 'en',       // which language to use (see LANGUAGES)
          networks: [           // which networks to include (see SHARING NETWORKS)
            'facebook',
            'messenger',
            'linkedin',
            'twitter',
            'pinterest'
          ],
          padding: 12,          // padding within buttons (INTEGER)
          radius: 5,            // the corner radius on each button (INTEGER)
          show_total: false,
          size: 40,             // the size of each button (INTEGER)

          // OPTIONAL PARAMETERS
          // url: 'https://www.sharethis.com', // (defaults to current url)
          // image: 'https://bit.ly/2CMhCMC',  // (defaults to og:image or twitter:image)
          description: '',       // (defaults to og:description or twitter:description)
          title: '',            // (defaults to og:title or twitter:title)
          message: 'I found this listing',     // (only for email sharing)
          subject: 'I found this listing',  // (only for email sharing)
          username: '@' // (only for twitter sharing)
        }}
      />
    </div>
  );
}
